import styles from './MyTasks.module.css';
import WidgetTile from '../WidgetTile';
import { Task } from '../../../types';

interface TaskItemProps {
  title: string;
  description: string;
  dueDate: string;
}

const TaskItem = ({ title, description, dueDate }: TaskItemProps) => {
  return (
    <WidgetTile title={title}>
      <div className={styles.details}>
        <p className={styles.description}>{description}</p>
        <p className={styles.dueDate}>Due: {dueDate}</p>
      </div>
    </WidgetTile>
  );
};

interface MyTasksProps {
  tasks: Task[];
}

const MyTasks = ({ tasks }: MyTasksProps) => {
  return (
    <ul className={styles.taskList} role="list" aria-label="My tasks">
      {tasks.map(task => (
        <li key={task.id}>
          <TaskItem {...task} />
        </li>
      ))}
    </ul>
  );
};

export default MyTasks;
